import React from 'react'

import { get, TextBody } from '@ally/metronome-ui'
import styled from 'styled-components'
import { AccountDetails } from '../../types'
import { getServerTimeShortDate } from '../../utils/formatter'

const AcctClosed = styled.span`
  color: ${get.colors('error')};
`

const ClosedTextBody = styled(TextBody)`
  padding-left: ${get.space('xs')};
`
const ClosedAcctWrapper = styled.div`
  padding-top: 5px;
  padding-left: 30px;
  padding-right: 30px;
  &:after {
    content: '';
    margin: auto;
    width: 100%;
    display: block;
    padding-top: 5px;
    border-bottom: thin solid ${get.colors('slate-2')};
  }
`

export const ClosedAccountLabel: React.FC<{ account: AccountDetails }> = ({
  account,
}) => {
  if (account.accountStatus === 'Closed' && account.acctClosedDate) {
    return (
      <ClosedAcctWrapper>
        <ClosedTextBody size="md" tag="p" weight="normal">
          <AcctClosed data-testid="closedAcctMessage">
            Account Closed - {getServerTimeShortDate(account.acctClosedDate)}.{' '}
          </AcctClosed>{' '}
          Details for this account will be available online for 60 days from the
          closed date.
        </ClosedTextBody>
      </ClosedAcctWrapper>
    )
  }
  return <></>
}
